import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  insertionOrders: [],
  folders: [], // ownerProfileId が index
  creatives: {}, // folder 選択した際に読み込む
  currentResource: null, // 開いているフォルダーの所属リソース
  currentFolder: null,
  currentCreative: null,
  loading: {
    insertionOrders: false,
    folders: [], // ownerProfileId が index
    creatives: false,
  },
  selectedCreatives: [],
  selectedCreativeTypes: null,
  selectedAuditStatuses: null,
  searchKeyword: '',
  pageNo: 1,
  pageSize: 20,
  sortOptions: {
    sortBy: 'id',
    descending: true,
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
